import './Story.css';
import React from "react";
import Footer from './Footer';
import {Link} from 'react-router-dom'
import storyList from './stories/storyList.js'


function Stories(props) {
    return (
                <div className="stories">
            <Link className="link" to="/" >
                <p className="backButton"> back to home </p>
            </Link>
            {/* <img className="storyHeaderImage" src={storyHeader} alt="two pink shimmering butterflies" /> */}
            <h1 className="storiesHeaderText"> Stories </h1>
            <div className="storyListRow">
            {storyList.map((story, index) => ( 
                <a className="href" href={"/story/" + story.shortName}>
                <div className="storyPreviewBox">
                    <h1 className="storyPreviewTitle"> {story.title}</h1>
                    <p className="storyPreviewText"> {story.preview} </p>
                </div>
                </a>
            ))}
            </div>
            <Footer/>
        </div>
    )
}

export default Stories;